import React from 'react'
import DocumentTitle from 'react-document-title'
import { Button, ButtonGroup } from 'react-bootstrap'

class ImportRecords extends React.Component {

  render () {
    return (
      <DocumentTitle title="Import records">
        <div>
          <h3>Import records</h3>
          <p>What type of data would you like to import?</p>
          <ButtonGroup>
            <Button href="/properties/import">Properties</Button>
            <Button href="/sales/import">Sales</Button>
            <Button href="/leases/import">Leases</Button>
            <Button href="/incexps/import">Income &amp; expenses</Button>
            <Button href="/consts/import">Construction costs</Button>
          </ButtonGroup>
        </div>
      </DocumentTitle>
    )
  }
}

export default ImportRecords



// WEBPACK FOOTER //
// ./modules/shared/pages/record/importRecords.js